"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgShrink = function SvgShrink(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.78 11.924a23.02 23.02 0 0 0 5.457.175c.54-.05 1.025-.409 1.157-.962.053-.222.099-.48.113-.74a2.48 2.48 0 0 0-.072-.714c-.138-.566-.682-.846-1.196-.855l-1.169-.022a81.238 81.238 0 0 0 3.58-4.01c.398-.48.507-1.159.059-1.676a8.397 8.397 0 0 0-.836-.834c-.514-.445-1.185-.33-1.658.069-.786.664-2.216 1.902-4.003 3.587L15.19 4.76c-.01-.512-.287-1.055-.851-1.193a2.456 2.456 0 0 0-.713-.073c-.26.014-.516.06-.738.113-.552.133-.909.618-.961 1.155-.195 1.981-.125 4.066.12 5.501.152.888.861 1.522 1.733 1.66ZM4.763 11.9a23.035 23.035 0 0 1 5.456.176c.872.139 1.582.773 1.734 1.66.245 1.436.314 3.52.12 5.501-.053.538-.41 1.023-.962 1.155a4.16 4.16 0 0 1-.737.114 2.459 2.459 0 0 1-.713-.073c-.565-.139-.842-.681-.851-1.194l-.022-1.181a100.598 100.598 0 0 1-4.004 3.587c-.473.4-1.143.513-1.658.068a8.443 8.443 0 0 1-.835-.834c-.449-.517-.34-1.196.06-1.676a81.1 81.1 0 0 1 3.578-4.01l-1.169-.021c-.514-.01-1.057-.289-1.195-.855a2.479 2.479 0 0 1-.072-.714c.014-.261.06-.518.113-.74.131-.553.616-.913 1.157-.963Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgShrink);
var _default = exports["default"] = Memo;